import { Component, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { getSessionItem } from '../shared/utils';
import { HeaderComponent } from '../shared/header/header.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  imports: [CommonModule, RouterModule, HeaderComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {

  @ViewChild('iframeRef') iframeRef!: ElementRef<HTMLIFrameElement>;
  frontend: string = '';
  userAccount: { name?: string } = {};
  iframeSrc: any = null;

  constructor(private route: ActivatedRoute, private router: Router, private sanitizer: DomSanitizer) {
    this.route.queryParams.subscribe(queryParams => {
      const frontend = queryParams['app'];
      this.frontend = frontend;

      // this.loadIframe();
    });
  }

  ngOnInit() {
    this.getNoCacheUrl();

    // check if user is logged in and redirect
    const user = getSessionItem('accessToken');
    if (!user) {
      this.router.navigate(['/signin']);
    }

    // get current user
    const currentUser = getSessionItem('userAccount');
    if (currentUser) {
      this.userAccount = currentUser;
    }


    // Listen for iframe readiness signal
    window.addEventListener('message', (event) => {
      if (event.data.type === 'iframe-ready') {

        var url = "https://biller.dev.afs1-nprd.aws-ug.sbgrp.cloud";

        if (this.frontend === 'bol-validation-tool') {
          // url = "https://bolvalidation.stanbicbank.co.ug:8890/redirect";
        }

        if (this.frontend === 'res') {
          url = "https://wa-sbuga-cimsresfrontend-nonprod.azurewebsites.net/redirect";
        }

        if (this.frontend === 'papss') {
          url = "https://uugpapss.ug.sbicdirectory.com:5011/redirect";
        }

        if (this.frontend === 'bancassurance') {
          url = "https://biller.dev.afs1-nprd.aws-ug.sbgrp.cloud:8443/";
        }

        if (this.frontend === 'res') {
          url = "https://wa-sbuga-cimsresfrontend-nonprod.azurewebsites.net/redirect";
        }

        if (this.frontend === 'trade') {
          url = "https://wa-sbuga-cimstradefrontend-nonprod.azurewebsites.net/redirect";
        }

        // https://cims.stanbicbank.co.ug:8895/cims/redirect
        const user = getSessionItem('userAccount');
        const token = getSessionItem('accessToken');
        const message = {
          sessionToken: token,
          baseUrl: "https://wa-sbuga-cimsauth-nonprod.azurewebsites.net/cims/redirect",
          userAccount: {
            name: user.name,
            username: this.frontend === 'bol-validation-tool' ? user.username.toLowerCase() : user.username
          }
        };
        const iframe = this.iframeRef?.nativeElement;
        const billerUrl = url;
        iframe.contentWindow?.postMessage(message, billerUrl);
      }
    });

  }

  loadIframe() {
    // Give the iframe time to load before posting the message
    setTimeout(() => {
      const iframe = this.iframeRef?.nativeElement;

      if (iframe) {
        iframe.onload = () => {
          let billerUrl = `https://biller.biller.afs1-prd.aws-ug.sbgrp.cloud`;

          const user = getSessionItem('userAccount');
          const token = getSessionItem('accessToken');
          if (user && token) {
            const message = {
              sessionToken: token,
              baseUrl: "https://cims.stanbicbank.co.ug:8895/cims/redirect",
              userAccount: {
                name: user.name,
                username: user.username
              }
            };

            if (this.frontend === 'biller') {
              iframe.contentWindow?.postMessage(message, billerUrl);
            }

            if (this.frontend === 'res') {
              billerUrl = "https://cimsres.stanbicbank.co.ug:8897/redirect";
              iframe.contentWindow?.postMessage(message, billerUrl);
            }

            if (this.frontend === 'res') {
              billerUrl = "https://wa-sbuga-cimsresfrontend-nonprod.azurewebsites.net/redirect";
              iframe.contentWindow?.postMessage(message, billerUrl);
            }

            if (this.frontend === 'papss') {
              billerUrl = "https://uugpapss.ug.sbicdirectory.com:5011/redirect";
              iframe.contentWindow?.postMessage(message, billerUrl);
            }

            if (this.frontend === 'trade') {
              billerUrl = "https://wa-sbuga-cimstradefrontend-nonprod.azurewebsites.net";
              iframe.contentWindow?.postMessage(message, billerUrl);
            }

            else {
              this.router.navigate(['/cims']);
            }

          }
          else {
            this.router.navigate(['/signin']);
          }

        };
      }
    }, 1000); // Delay can be adjusted
  }

  getNoCacheUrl() {
    const baseUrl = "https://uugpapss.ug.sbicdirectory.com:5011/redirect";
    const noCacheUrl = `${baseUrl}?t=${Date.now()}`;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(noCacheUrl); // cache buster
  }

}
